import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0e2483a1&scoped=true&functional=true&"
var script = {}
import style0 from "./index.styl?vue&type=style&index=0&id=0e2483a1&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "0e2483a1",
  null
  
)

export default component.exports